import { render, staticRenderFns } from "./ClientsListSalesTerritoryReport.vue?vue&type=template&id=18e63fe1&"
import script from "./ClientsListSalesTerritoryReport.vue?vue&type=script&lang=js&"
export * from "./ClientsListSalesTerritoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports